import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledBoxGeneric, StyledBoxDown, StyledButton } from './style';
import { ABOUT_YOU } from '../../../../constants/literals/modals';
import Modal from '../../../core/Modal';
import Editor from '../../../core/Editor';

class Aboutyou extends Component {
  constructor(props) {
    super(props);
    const { dataAboutYou } = props;

    this.state = {
      currentContent: dataAboutYou,
      btnIsDisabled: true
    };
  }

  updateContent = data => {
    const { dataAboutYou } = this.props;
    const updateBtnStatus = dataAboutYou === data;

    this.setState({ currentContent: data, btnIsDisabled: updateBtnStatus });
  };

  render() {
    const { currentContent, btnIsDisabled } = this.state;
    const { onCloseModal, onAcceptModal } = this.props;
    return (
      <Modal title={ABOUT_YOU.TITLE} clickCloseIcon={onCloseModal}>
        <StyledBoxGeneric>
          <Editor
            value={currentContent}
            onChange={e => this.updateContent(e)}
          />
          <StyledBoxDown>
            <StyledButton modal onClick={onCloseModal}>
              {ABOUT_YOU.CANCEL}
            </StyledButton>
            <StyledButton
              secondary
              disabled={btnIsDisabled}
              onClick={() => {
                onAcceptModal(currentContent);
              }}
            >
              {ABOUT_YOU.ACCEPT}
            </StyledButton>
          </StyledBoxDown>
        </StyledBoxGeneric>
      </Modal>
    );
  }
}

Aboutyou.propTypes = {
  onCloseModal: PropTypes.func,
  onAcceptModal: PropTypes.func,
  dataAboutYou: PropTypes.string
};

Aboutyou.defaultProps = {
  dataAboutYou: ''
};

export default Aboutyou;
